export const STATUS_COLORS = {
  passed: '#16a34a',
  fail: '#dc2626',
  warning: '#d97706',
};

// Palette used to assign a stable, distinct color to each value of a
// finite/enumerable column (e.g. Prompt Type). Deliberately excludes the
// STATUS_COLORS hues so those columns never look the same by coincidence.
const VALUE_PALETTE = [
  '#2563eb', '#7c3aed', '#db2777', '#65a30d',
  '#0891b2', '#4f46e5', '#c026d3', '#0d9488',
  '#9333ea', '#0284c7',
];

function hashString(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

/**
 * Deterministically assigns a color to any value so the same value always
 * renders with the same color, without needing a predefined color map.
 */
export function getColorForValue(value) {
  const str = String(value ?? '').trim();
  if (!str) return '#6b7280';
  return VALUE_PALETTE[hashString(str) % VALUE_PALETTE.length];
}
